import { GlobeViewMapType } from '~/client/graph/types.generated'

// Generated graph types only: the stores read from here, so importing one back is a cycle — which
// surfaces as a runtime "cannot read properties of undefined", not a type error.
export enum Projection {
  globe = 'globe',
  mercator = 'mercator',
}

// One place, so a basemap change cannot reach some maps and not others.
export const STREET_STYLE_CODE = 'mapbox://styles/mapbox/standard'
export const SATELLITE_STYLE_CODE = 'mapbox://styles/mapbox/standard-satellite'

// Each store still keeps its own projection value — a view mode is per-surface — but the enum, the
// mapping and the flip are decided here.
export function basemapStyleFor(mapType: GlobeViewMapType): string {
  return mapType === GlobeViewMapType.Satellite
    ? SATELLITE_STYLE_CODE
    : STREET_STYLE_CODE
}

export function nextProjection(current: Projection): Projection {
  return current === Projection.globe ? Projection.mercator : Projection.globe
}

// Mapbox's Standard style declares globe, so passing no projection is not the same as mercator.
export const DEFAULT_PROJECTION = Projection.mercator
